import { ChainId } from '@donaswap/sdk'

// Revalidate interval in milliseconds
export const POOLS_FAST_REVALIDATE = {
  [ChainId.FIRECHAIN]: 10_000,
  [ChainId.RINIA]: 10_000,
  [ChainId.BSC_TESTNET]: 10_000,
  [ChainId.BSC]: 10_000,
  [ChainId.ETHEREUM]: 20_000,
  [ChainId.GOERLI]: 20_000,
  [ChainId.SEPOLIA]: 20_000,
  [ChainId.POLYGON]: 20_000,
  [ChainId.POLYGON_MUMBAI]: 20_000,
  [ChainId.CRO]: 20_000,
  [ChainId.CRO_TESTNET]: 20_000,
  [ChainId.AVALANCHE]: 20_000,
  [ChainId.AVALANCHE_FUJI]: 20_000,
  [ChainId.FANTOM_OPERA]: 20_000,
  [ChainId.FANTOM_TESTNET]: 20_000,
  [ChainId.CELO]: 20_000,
  [ChainId.CELO_ALFAJORES]: 20_000,
  [ChainId.OPTIMISM]: 20_000,
  [ChainId.OPTIMISM_GOERLI]: 20_000,
  [ChainId.SHIBARIUM]: 20_000,
  [ChainId.SHIBARIUM_TESTNET]: 20_000,
  [ChainId.PULSECHAIN]: 20_000,
  [ChainId.PULSECHAIN_TESTNET]: 20_000,
  [ChainId.XEN]: 20_000,
  [ChainId.XEN_DEVNET]: 20_000,
  [ChainId.HARMONY]: 20_000,
  [ChainId.HARMONY_TESTNET]: 20_000,
  [ChainId.COINEX]: 20_000,
  [ChainId.COINEX_TESTNET]: 20_000,
  [ChainId.DOGECHAIN]: 20_000,
  [ChainId.DOGECHAIN_TESTNET]: 20_000,
  [ChainId.ETHEREUM_CLASSIC]: 20_000,
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: 20_000,
  [ChainId.FUSION]: 20_000,
  [ChainId.FUSION_TESTNET]: 20_000,
  [ChainId.HECO]: 20_000,
  [ChainId.HECO_TESTNET]: 20_000,
  [ChainId.KCC]: 20_000,
  [ChainId.KCC_TESTNET]: 20_000,
  [ChainId.KLAYTN]: 20_000,
  [ChainId.KLAYTN_BAOBAB]: 20_000,
  [ChainId.OKXCHAIN]: 20_000,
  [ChainId.OKXCHAIN_TESTNET]: 20_000,
  [ChainId.THETHA]: 20_000,
  [ChainId.THETHA_TESTNET]: 20_000,
  [ChainId.ULTRON]: 20_000,
  [ChainId.ULTRON_TESTNET]: 20_000,
  [ChainId.MOONBEAM]: 20_000,
  [ChainId.MOONRIVER]: 20_000,
  [ChainId.MOONBASE_ALPHA]: 20_000,
  [ChainId.AURORA]: 20_000,
  [ChainId.AURORA_TESTNET]: 20_000,
  [ChainId.BOBA]: 20_000,
  [ChainId.BOBA_GOERLI]: 20_000,
  [ChainId.GNOSIS]: 20_000,
  [ChainId.GNOSIS_CHIADO]: 20_000,
  [ChainId.METIS]: 20_000,
  [ChainId.METIS_GOERLI]: 20_000,
  [ChainId.TELOS]: 20_000,
  [ChainId.TELOS_TESTNET]: 20_000,
  [ChainId.SYSCOIN]: 20_000,
  [ChainId.SYSCOIN_TANENBAUM]: 20_000,
  [ChainId.IOTEX]: 20_000,
  [ChainId.IOTEX_TESTNET]: 20_000,
  [ChainId.SHIDEN]: 20_000,
  [ChainId.ASTAR]: 20_000,
  [ChainId.SHIBUNYA]: 20_000,
  [ChainId.FUSE]: 20_000,
  [ChainId.FUSE_SPARKNET]: 20_000,
  [ChainId.VELAS]: 20_000,
  [ChainId.VELAS_TESTNET]: 20_000,
  [ChainId.REI]: 20_000,
  [ChainId.REI_TESTNET]: 20_000,
  [ChainId.KEKCHAIN]: 20_000,
  [ChainId.KEKCHAIN_TESTNET]: 20_000,
  [ChainId.TOMOCHAIN]: 20_000,
  [ChainId.TOMOCHAIN_TESTNET]: 20_000,
  [ChainId.THUNDERCORE]: 20_000,
  [ChainId.THUNDERCORE_TESTNET]: 20_000,
  [ChainId.WANCHAIN]: 20_000,
  [ChainId.WANCHAIN_TESTNET]: 20_000,
  [ChainId.RSK]: 20_000,
  [ChainId.RSK_TESTNET]: 20_000,
  [ChainId.ELASTOS]: 20_000,
  [ChainId.ELASTOS_TESTNET]: 20_000,
  [ChainId.CONFLUX]: 20_000,
  [ChainId.CONFLUX_TESTNET]: 20_000,
  [ChainId.BRISECHAIN]: 20_000,
  [ChainId.BRISECHAIN_TESTNET]: 20_000,
  [ChainId.MUUCHAIN]: 20_000,
  [ChainId.MUUCHAIN_TESTNET]: 20_000,
  [ChainId.CANTO]: 20_000,
  [ChainId.CANTO_TESTNET]: 20_000,
  [ChainId.OASIS_EMERALD]: 20_000,
  [ChainId.OASIS_TESTNET]: 20_000,
  [ChainId.VISION]: 20_000,
  [ChainId.VISION_TESTNET]: 20_000,
  [ChainId.STEP]: 20_000,
  [ChainId.STEP_TESTNET]: 20_000,
  [ChainId.METER]: 20_000,
  [ChainId.METER_TESTNET]: 20_000,
  [ChainId.GODWOKEN]: 20_000,
  [ChainId.GODWOKEN_TESTNET]: 20_000,
  [ChainId.CALLISTO]: 20_000,
  [ChainId.CALLISTO_TESTNET]: 20_000,
  [ChainId.EVMOS]: 20_000,
  [ChainId.EVMOS_TESTNET]: 20_000,
  [ChainId.ENERGY_WEB_CHAIN]: 20_000,
  [ChainId.ENERGY_VOLTA]: 20_000,
  [ChainId.BASE]: 20_000,
  [ChainId.BASE_GOERLI]: 20_000,
  [ChainId.KAVA]: 20_000,
  [ChainId.KAVA_TESTNET]: 20_000,
  [ChainId.CLOVER]: 20_000,
  [ChainId.CLOVER_TESTNET]: 20_000,
  [ChainId.DEFICHAIN]: 20_000,
  [ChainId.DEFICHAIN_TESTNET]: 20_000,
  [ChainId.BRONOS]: 20_000,
  [ChainId.BRONOS_TESTNET]: 20_000,
  [ChainId.FILECOIN]: 20_000,
  [ChainId.FILECOIN_CALIBRATION]: 20_000,
  [ChainId.FLARE]: 20_000,
  [ChainId.FLARE_TESTNET]: 20_000,
  [ChainId.TARAXA]: 20_000,
  [ChainId.TARAXA_TESTNET]: 20_000,

  [ChainId.ARBITRUM_ONE]: 10_000,
  [ChainId.ARBITRUM_GOERLI]: 10_000,
  [ChainId.POLYGON_ZKEVM]: 15_000,
  [ChainId.POLYGON_ZKEVM_TESTNET]: 15_000,
  [ChainId.ZKSYNC]: 15_000,
  [ChainId.ZKSYNC_TESTNET]: 15_000,
  [ChainId.LINEA_TESTNET]: 20_000,
} as const satisfies Record<ChainId, number>

// Revalidate interval in milliseconds
export const POOLS_NORMAL_REVALIDATE = {
  [ChainId.FIRECHAIN]: 10_000,
  [ChainId.RINIA]: 10_000,
  [ChainId.BSC_TESTNET]: 15_000,
  [ChainId.BSC]: 15_000,
  [ChainId.ETHEREUM]: 20_000,
  [ChainId.GOERLI]: 20_000,
  [ChainId.SEPOLIA]: 20_000,
  [ChainId.POLYGON]: 20_000,
  [ChainId.POLYGON_MUMBAI]: 20_000,
  [ChainId.CRO]: 20_000,
  [ChainId.CRO_TESTNET]: 20_000,
  [ChainId.AVALANCHE]: 20_000,
  [ChainId.AVALANCHE_FUJI]: 20_000,
  [ChainId.FANTOM_OPERA]: 20_000,
  [ChainId.FANTOM_TESTNET]: 20_000,
  [ChainId.CELO]: 20_000,
  [ChainId.CELO_ALFAJORES]: 20_000,
  [ChainId.OPTIMISM]: 20_000,
  [ChainId.OPTIMISM_GOERLI]: 20_000,
  [ChainId.SHIBARIUM]: 20_000,
  [ChainId.SHIBARIUM_TESTNET]: 20_000,
  [ChainId.PULSECHAIN]: 20_000,
  [ChainId.PULSECHAIN_TESTNET]: 20_000,
  [ChainId.XEN]: 20_000,
  [ChainId.XEN_DEVNET]: 20_000,
  [ChainId.HARMONY]: 20_000,
  [ChainId.HARMONY_TESTNET]: 20_000,
  [ChainId.COINEX]: 20_000,
  [ChainId.COINEX_TESTNET]: 20_000,
  [ChainId.DOGECHAIN]: 20_000,
  [ChainId.DOGECHAIN_TESTNET]: 20_000,
  [ChainId.ETHEREUM_CLASSIC]: 20_000,
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: 20_000,
  [ChainId.FUSION]: 20_000,
  [ChainId.FUSION_TESTNET]: 20_000,
  [ChainId.HECO]: 20_000,
  [ChainId.HECO_TESTNET]: 20_000,
  [ChainId.KCC]: 20_000,
  [ChainId.KCC_TESTNET]: 20_000,
  [ChainId.KLAYTN]: 20_000,
  [ChainId.KLAYTN_BAOBAB]: 20_000,
  [ChainId.OKXCHAIN]: 20_000,
  [ChainId.OKXCHAIN_TESTNET]: 20_000,
  [ChainId.THETHA]: 20_000,
  [ChainId.THETHA_TESTNET]: 20_000,
  [ChainId.ULTRON]: 20_000,
  [ChainId.ULTRON_TESTNET]: 20_000,
  [ChainId.MOONBEAM]: 20_000,
  [ChainId.MOONRIVER]: 20_000,
  [ChainId.MOONBASE_ALPHA]: 20_000,
  [ChainId.AURORA]: 20_000,
  [ChainId.AURORA_TESTNET]: 20_000,
  [ChainId.BOBA]: 20_000,
  [ChainId.BOBA_GOERLI]: 20_000,
  [ChainId.GNOSIS]: 20_000,
  [ChainId.GNOSIS_CHIADO]: 20_000,
  [ChainId.METIS]: 20_000,
  [ChainId.METIS_GOERLI]: 20_000,
  [ChainId.TELOS]: 20_000,
  [ChainId.TELOS_TESTNET]: 20_000,
  [ChainId.SYSCOIN]: 20_000,
  [ChainId.SYSCOIN_TANENBAUM]: 20_000,
  [ChainId.IOTEX]: 20_000,
  [ChainId.IOTEX_TESTNET]: 20_000,
  [ChainId.SHIDEN]: 20_000,
  [ChainId.ASTAR]: 20_000,
  [ChainId.SHIBUNYA]: 20_000,
  [ChainId.FUSE]: 20_000,
  [ChainId.FUSE_SPARKNET]: 20_000,
  [ChainId.VELAS]: 20_000,
  [ChainId.VELAS_TESTNET]: 20_000,
  [ChainId.REI]: 20_000,
  [ChainId.REI_TESTNET]: 20_000,
  [ChainId.KEKCHAIN]: 20_000,
  [ChainId.KEKCHAIN_TESTNET]: 20_000,
  [ChainId.TOMOCHAIN]: 20_000,
  [ChainId.TOMOCHAIN_TESTNET]: 20_000,
  [ChainId.THUNDERCORE]: 20_000,
  [ChainId.THUNDERCORE_TESTNET]: 20_000,
  [ChainId.WANCHAIN]: 20_000,
  [ChainId.WANCHAIN_TESTNET]: 20_000,
  [ChainId.RSK]: 20_000,
  [ChainId.RSK_TESTNET]: 20_000,
  [ChainId.ELASTOS]: 20_000,
  [ChainId.ELASTOS_TESTNET]: 20_000,
  [ChainId.CONFLUX]: 20_000,
  [ChainId.CONFLUX_TESTNET]: 20_000,
  [ChainId.BRISECHAIN]: 20_000,
  [ChainId.BRISECHAIN_TESTNET]: 20_000,
  [ChainId.MUUCHAIN]: 20_000,
  [ChainId.MUUCHAIN_TESTNET]: 20_000,
  [ChainId.CANTO]: 20_000,
  [ChainId.CANTO_TESTNET]: 20_000,
  [ChainId.OASIS_EMERALD]: 20_000,
  [ChainId.OASIS_TESTNET]: 20_000,
  [ChainId.VISION]: 20_000,
  [ChainId.VISION_TESTNET]: 20_000,
  [ChainId.STEP]: 20_000,
  [ChainId.STEP_TESTNET]: 20_000,
  [ChainId.METER]: 20_000,
  [ChainId.METER_TESTNET]: 20_000,
  [ChainId.GODWOKEN]: 20_000,
  [ChainId.GODWOKEN_TESTNET]: 20_000,
  [ChainId.CALLISTO]: 20_000,
  [ChainId.CALLISTO_TESTNET]: 20_000,
  [ChainId.EVMOS]: 20_000,
  [ChainId.EVMOS_TESTNET]: 20_000,
  [ChainId.ENERGY_WEB_CHAIN]: 20_000,
  [ChainId.ENERGY_VOLTA]: 20_000,
  [ChainId.BASE]: 20_000,
  [ChainId.BASE_GOERLI]: 20_000,
  [ChainId.KAVA]: 20_000,
  [ChainId.KAVA_TESTNET]: 20_000,
  [ChainId.CLOVER]: 20_000,
  [ChainId.CLOVER_TESTNET]: 20_000,
  [ChainId.DEFICHAIN]: 20_000,
  [ChainId.DEFICHAIN_TESTNET]: 20_000,
  [ChainId.BRONOS]: 20_000,
  [ChainId.BRONOS_TESTNET]: 20_000,
  [ChainId.FILECOIN]: 20_000,
  [ChainId.FILECOIN_CALIBRATION]: 20_000,
  [ChainId.FLARE]: 20_000,
  [ChainId.FLARE_TESTNET]: 20_000,
  [ChainId.TARAXA]: 20_000,
  [ChainId.TARAXA_TESTNET]: 20_000,

  [ChainId.ARBITRUM_ONE]: 15_000,
  [ChainId.ARBITRUM_GOERLI]: 15_000,
  [ChainId.POLYGON_ZKEVM]: 15_000,
  [ChainId.POLYGON_ZKEVM_TESTNET]: 15_000,
  [ChainId.ZKSYNC]: 15_000,
  [ChainId.ZKSYNC_TESTNET]: 15_000,
  [ChainId.LINEA_TESTNET]: 20_000,

} as const satisfies Record<ChainId, number>

export const POOLS_SLOW_REVALIDATE = {
  [ChainId.FIRECHAIN]: 10_000,
  [ChainId.RINIA]: 10_000,
  [ChainId.BSC_TESTNET]: 20_000,
  [ChainId.BSC]: 20_000,
  [ChainId.ETHEREUM]: 40_000,
  [ChainId.GOERLI]: 40_000,
  [ChainId.SEPOLIA]: 20_000,
  [ChainId.POLYGON]: 20_000,
  [ChainId.POLYGON_MUMBAI]: 20_000,
  [ChainId.CRO]: 20_000,
  [ChainId.CRO_TESTNET]: 20_000,
  [ChainId.AVALANCHE]: 20_000,
  [ChainId.AVALANCHE_FUJI]: 20_000,
  [ChainId.FANTOM_OPERA]: 20_000,
  [ChainId.FANTOM_TESTNET]: 20_000,
  [ChainId.CELO]: 20_000,
  [ChainId.CELO_ALFAJORES]: 20_000,
  [ChainId.OPTIMISM]: 20_000,
  [ChainId.OPTIMISM_GOERLI]: 20_000,
  [ChainId.SHIBARIUM]: 20_000,
  [ChainId.SHIBARIUM_TESTNET]: 20_000,
  [ChainId.PULSECHAIN]: 20_000,
  [ChainId.PULSECHAIN_TESTNET]: 20_000,
  [ChainId.XEN]: 20_000,
  [ChainId.XEN_DEVNET]: 20_000,
  [ChainId.HARMONY]: 20_000,
  [ChainId.HARMONY_TESTNET]: 20_000,
  [ChainId.COINEX]: 20_000,
  [ChainId.COINEX_TESTNET]: 20_000,
  [ChainId.DOGECHAIN]: 20_000,
  [ChainId.DOGECHAIN_TESTNET]: 20_000,
  [ChainId.ETHEREUM_CLASSIC]: 20_000,
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: 20_000,
  [ChainId.FUSION]: 20_000,
  [ChainId.FUSION_TESTNET]: 20_000,
  [ChainId.HECO]: 20_000,
  [ChainId.HECO_TESTNET]: 20_000,
  [ChainId.KCC]: 20_000,
  [ChainId.KCC_TESTNET]: 20_000,
  [ChainId.KLAYTN]: 20_000,
  [ChainId.KLAYTN_BAOBAB]: 20_000,
  [ChainId.OKXCHAIN]: 20_000,
  [ChainId.OKXCHAIN_TESTNET]: 20_000,
  [ChainId.THETHA]: 20_000,
  [ChainId.THETHA_TESTNET]: 20_000,
  [ChainId.ULTRON]: 20_000,
  [ChainId.ULTRON_TESTNET]: 20_000,
  [ChainId.MOONBEAM]: 20_000,
  [ChainId.MOONRIVER]: 20_000,
  [ChainId.MOONBASE_ALPHA]: 20_000,
  [ChainId.AURORA]: 20_000,
  [ChainId.AURORA_TESTNET]: 20_000,
  [ChainId.BOBA]: 20_000,
  [ChainId.BOBA_GOERLI]: 20_000,
  [ChainId.GNOSIS]: 20_000,
  [ChainId.GNOSIS_CHIADO]: 20_000,
  [ChainId.METIS]: 20_000,
  [ChainId.METIS_GOERLI]: 20_000,
  [ChainId.TELOS]: 20_000,
  [ChainId.TELOS_TESTNET]: 20_000,
  [ChainId.SYSCOIN]: 20_000,
  [ChainId.SYSCOIN_TANENBAUM]: 20_000,
  [ChainId.IOTEX]: 20_000,
  [ChainId.IOTEX_TESTNET]: 20_000,
  [ChainId.SHIDEN]: 20_000,
  [ChainId.ASTAR]: 20_000,
  [ChainId.SHIBUNYA]: 20_000,
  [ChainId.FUSE]: 20_000,
  [ChainId.FUSE_SPARKNET]: 20_000,
  [ChainId.VELAS]: 20_000,
  [ChainId.VELAS_TESTNET]: 20_000,
  [ChainId.REI]: 20_000,
  [ChainId.REI_TESTNET]: 20_000,
  [ChainId.KEKCHAIN]: 20_000,
  [ChainId.KEKCHAIN_TESTNET]: 20_000,
  [ChainId.TOMOCHAIN]: 20_000,
  [ChainId.TOMOCHAIN_TESTNET]: 20_000,
  [ChainId.THUNDERCORE]: 20_000,
  [ChainId.THUNDERCORE_TESTNET]: 20_000,
  [ChainId.WANCHAIN]: 20_000,
  [ChainId.WANCHAIN_TESTNET]: 20_000,
  [ChainId.RSK]: 20_000,
  [ChainId.RSK_TESTNET]: 20_000,
  [ChainId.ELASTOS]: 20_000,
  [ChainId.ELASTOS_TESTNET]: 20_000,
  [ChainId.CONFLUX]: 20_000,
  [ChainId.CONFLUX_TESTNET]: 20_000,
  [ChainId.BRISECHAIN]: 20_000,
  [ChainId.BRISECHAIN_TESTNET]: 20_000,
  [ChainId.MUUCHAIN]: 20_000,
  [ChainId.MUUCHAIN_TESTNET]: 20_000,
  [ChainId.CANTO]: 20_000,
  [ChainId.CANTO_TESTNET]: 20_000,
  [ChainId.OASIS_EMERALD]: 20_000,
  [ChainId.OASIS_TESTNET]: 20_000,
  [ChainId.VISION]: 20_000,
  [ChainId.VISION_TESTNET]: 20_000,
  [ChainId.STEP]: 20_000,
  [ChainId.STEP_TESTNET]: 20_000,
  [ChainId.METER]: 20_000,
  [ChainId.METER_TESTNET]: 20_000,
  [ChainId.GODWOKEN]: 20_000,
  [ChainId.GODWOKEN_TESTNET]: 20_000,
  [ChainId.CALLISTO]: 20_000,
  [ChainId.CALLISTO_TESTNET]: 20_000,
  [ChainId.EVMOS]: 20_000,
  [ChainId.EVMOS_TESTNET]: 20_000,
  [ChainId.ENERGY_WEB_CHAIN]: 20_000,
  [ChainId.ENERGY_VOLTA]: 20_000,
  [ChainId.BASE]: 20_000,
  [ChainId.BASE_GOERLI]: 20_000,
  [ChainId.KAVA]: 20_000,
  [ChainId.KAVA_TESTNET]: 20_000,
  [ChainId.CLOVER]: 20_000,
  [ChainId.CLOVER_TESTNET]: 20_000,
  [ChainId.DEFICHAIN]: 20_000,
  [ChainId.DEFICHAIN_TESTNET]: 20_000,
  [ChainId.BRONOS]: 20_000,
  [ChainId.BRONOS_TESTNET]: 20_000,
  [ChainId.FILECOIN]: 20_000,
  [ChainId.FILECOIN_CALIBRATION]: 20_000,
  [ChainId.FLARE]: 20_000,
  [ChainId.FLARE_TESTNET]: 20_000,
  [ChainId.TARAXA]: 20_000,
  [ChainId.TARAXA_TESTNET]: 20_000,
  
  [ChainId.ARBITRUM_ONE]: 20_000,
  [ChainId.ARBITRUM_GOERLI]: 20_000,
  [ChainId.POLYGON_ZKEVM]: 20_000,
  [ChainId.POLYGON_ZKEVM_TESTNET]: 20_000,
  [ChainId.ZKSYNC]: 20_000,
  [ChainId.ZKSYNC_TESTNET]: 20_000,
  [ChainId.LINEA_TESTNET]: 30_000,
} as const satisfies Record<ChainId, number>
